import {NgModule} from "@angular/core";
import {IntAttrBindingDirective} from "./int-attr-binding.directive";

@NgModule({
  declarations: [
    IntAttrBindingDirective
  ],
  exports: [
    IntAttrBindingDirective
  ]
})
export class IntAttrBindingModule {}
